export function getSeason(date?: Date | string) {
  return isWinter(date ?? '') ? 'w' : 's'
}
